import { Routes, Route, Navigate } from "react-router-dom";
import {DigitalPrint, FinancialService, Business, DevApi, TcsInsights, Travel} from '../../../helpers/modules'

const valueroutes = [
    {routeName: 'digital-printing' , component: <DigitalPrint/>},
    {routeName: 'financial-services' , component: <FinancialService/>},
    {routeName: 'tcs-business' , component: <Business/>},
    {routeName: 'tcs-dev-api' , component: <DevApi/>},
    {routeName: 'tcs-insights' , component: <TcsInsights/>},
    {routeName: 'travel-and-tour' , component: <Travel/>},
];

const ValueAddedRoutes = () => {
    return (
    <Routes>
       {valueroutes.map((route, key)=> ( <Route key={key}  path={route.routeName} element={route.component}></Route> ))}
       <Route path="*" element={<Navigate to="/" /> }/>
    </Routes>)
}

export default ValueAddedRoutes;